
import { A2AOrchestrationPlan } from '@/utils/a2a/types';
import { createAdaptiveOrchestrationPlan, updateAdaptivePlanStatus, getActivePlans } from '@/utils/a2a/orchestration/adaptive';

export function createOrchestrationPlan(
  task: string,
  capabilities: string[],
  complexity: 'simple' | 'medium' | 'complex'
): A2AOrchestrationPlan {
  const plan = createAdaptiveOrchestrationPlan(task, capabilities, complexity);
  
  if (plan.agentSequence.length === 0) {
    throw new Error("No suitable agents found for this task");
  }
  
  updateAdaptivePlanStatus(plan.id, 'in-progress');
  return plan;
}
